import { ButtonGroup, Table } from 'react-bootstrap';
import './InstalationGrid.scss';
import { useTranslation } from 'react-i18next';
import { Spinner } from 'react-bootstrap';
import { useEffect, useState } from 'react';
import { Instalation } from '../../../utils/models/Instalation';
import { createColumnHelper, SortingState } from '@tanstack/react-table';
import { DataGrid }  from 'aw-data-grid';

const InstalationGrid = (props: {
    instalations: Instalation[];
    onEditClick: (c: Instalation) => void;
    onDeleteClick: (c: Instalation) => void;
    edit: boolean;
    loading: boolean;
    onContainerClick: (c: Instalation) => void;
    pagination: { pageIndex: number; pageSize: number };
    setPagination: React.Dispatch<React.SetStateAction<{ pageIndex: number; pageSize: number }>>;
    total: number;
    filters: any;
    setFilters: any;
    sorting: SortingState;
    setSorting: React.Dispatch<React.SetStateAction<any>>;
    manual?: boolean;
}) => {
    const { t } = useTranslation();
    const [instalations, setInstalations] = useState<Instalation[]>(props.instalations)
    useEffect(() => {
        setInstalations(props.instalations.sort((a, b) => a.idinstalation - b.idinstalation));
    }, [props.instalations]);

    const columnHelper = createColumnHelper<Instalation>();

    const columns = [
        columnHelper.accessor('name', {
            header: t('Name'),
            cell: info => info.getValue(),
        }),
        columnHelper.accessor('address', {
            header: t('Address'),
            cell: info => info.getValue(),
        }),
        columnHelper.accessor('city', {
            header: t('City'),
            cell: info => info.getValue(),
        }),
        columnHelper.accessor('active', {
            header: t('Active'),
            meta: {
                filterOptions: [ 
                    { label: t('Yes'), value: true},
                    {label: t('No'), value:false}
                    
                    ]
            },
            cell: (info: any) => (info.getValue() ? t('Yes') : t('No')),
        }),
        columnHelper.display({
            id: 'actions',
            header: '',
            enableSorting: false,
            enableColumnFilter: false,
            cell: ({ row }) => {
                const i = row.original as Instalation;
                return (
                    <div className="text-end">
                        <ButtonGroup>
                            <button
                                onClick={() => props.onDeleteClick(i)}
                                className="btn-Simple text-danger"
                            >
                                <i className="bi bi-trash"></i>
                            </button>
                        </ButtonGroup>
                    </div>
                );
            },
        }),
    ];
    return (
        <div className={`p-2 rounded-1 ${!props.edit ? 'dashboardGridContainer' : 'editGridContainer'}`} id='gridContainerContainer'>
            {!props.edit && <p className="mt-1 h4 text-center">{t('Installations')}</p>}
            {props.loading ? (
                <div className="text-center pt-5">
                    <Spinner animation="border" variant="success" />
                </div>
            ) : (
                <DataGrid
                    data={instalations}
                    columnFilters={props.filters}
                    onColumnFiltersChange={props.setFilters}
                    pagination={props.pagination}
                    onRowClick={(i) => props.onEditClick(i)} 
                    onPaginationChange={props.setPagination}
                    columns={columns}
                    pageCount={props.total}
                    sorting={props.sorting}
                    onSortingChange={props.setSorting}
                    manual={props.manual}
                    filtersPlaceholder={t('Search')}
                />
            ) }
        </div>
    );
};

export default InstalationGrid